// extracted by mini-css-extract-plugin
module.exports = {"media-card-container":"CardMedia_media-card-container__4yZum","media-card-image":"CardMedia_media-card-image__IF4Ae"};